(function(root){
  const api={
    offer(cfg,set,id,pendant){
      if(!set)return {set:false,valid:true};
      if(!cfg.chainEnabled||cfg.currency!=='USD')return {set:true,valid:false,error:'This set offer is unavailable.'};
      const chain=(cfg.chains||[]).find(v=>String(v.id)===String(id));
      if(!chain?.available)return {set:true,valid:false,error:'This chain length is sold out. Choose another length or pendant only.'};
      if(pendant?.cents!==5900||chain.cents!==9900)return {set:true,valid:false,error:'The set price has changed. Please contact us before ordering the set.'};
      return {set:true,valid:true,chain,total:12900};
    },
    payload(id,props,offer,pair){
      if(!offer.valid)throw Error('Invalid set');
      const items=[{id,quantity:1,properties:{...props}}];
      if(offer.set){
        if(!pair)throw Error('Pair reference required');
        Object.assign(items[0].properties,{'Pair reference':pair,'Package':'Pendant + 4mm chain','Chain length':offer.chain.title});
        items.push({id:offer.chain.id,quantity:1,properties:{'Pair reference':pair,'Package':'4mm chain for personalized pendant'}});
      }
      return {items};
    }
  };
  if(typeof module!=='undefined')module.exports=api;
  else root.VestaChain=api;
})(typeof window!=='undefined'?window:this);
